import React from 'react';

// T0 — Chip sélectionnable (filtres). Actif = rempli (couleur module si fournie).
export const Pill = ({ children, active = false, color, onClick, className = '' }) => {
  const activeStyle = active && color ? { backgroundColor: color, color: '#fff', borderColor: color } : undefined;
  return (
    <button
      type="button"
      onClick={onClick}
      style={activeStyle}
      className={`px-3 py-1 rounded-full text-sm font-medium border transition-colors ${
        active
          ? (color ? '' : 'bg-blue-500 text-white border-blue-500')
          : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700'
      } ${className}`}
    >
      {children}
    </button>
  );
};

export default Pill;
